'use client';

import { useEffect } from 'react';

/**
 * Browser-ийн Back/Forward cache (bfcache)-аас хуудас сэргэх үед дахин ачаална.
 *
 * Гадаад линк (жишээ нь market.zangia.mn)-ээр гарч, Back дарахад Firefox хуудсыг
 * хөлдөөсөн төлвөөр нь (дунд зуурын router/prefetch/menu төлөвтэй) сэргээдэг.
 * Тэр үед Next.js router-ийн хүлээгдэж байсан хүсэлтүүд тасарсан тул цэс,
 * линкүүд дарагдахгүй болдог. `pageshow` + `persisted` үед шинэчилж ачаалснаар
 * цэвэр төлөв гарна. Reload-ийн дараа `persisted` = false тул давталт үүсэхгүй.
 */
export default function BfcacheRestoreReload() {
  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload();
      }
    };
    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);

  return null;
}
